import React from 'react'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import { Tab, Tabs, OutlinedInput, ToggleButton, Switch } from '@mui/material'
import { withStyles } from 'tss-react/mui'

export const BasicButton = styled(Button)(
  ({ theme }) => `
  line-height: 21.33px;
  font-weight: 700;
  border-radius: 32px;
  width: 140px !important;
  color: ${theme.colors.textButton}
  text-transform: none;
  &.MuiButton-root {
    text-transform: none;
  }
  :active {
    color: ${theme.colors.highlightButtonText}
  }
`
)

export const HighlightButton = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  textTransform: 'unset !important',
  paddingLeft: '35px',
  paddingRight: '35px',
  borderRadius: '36px !important',
  fontSize: '18px !important',
  fontWeight: '700 !important',
  height: '58px !important',
  width: '135px !important',
  contained: {
    boxShadow: '0 0 0 0'
  },
  '&.Mui-disabled': {
    background: theme.colors.logInDisabledBackground,
    color: theme.colors.textButton
  }
}))

export const RoundedButton = styled(Button)(({ theme }) => ({
  lineHeight: '21.33px',
  fontWeight: 700,
  borderRadius: '32px',
  width: '140px !important',
  color: theme.colors.highlightButtonText,
  textTransform: 'none',
  '&.MuiButton-root': {
    textTransform: 'none'
  },
  '&.Mui-disabled': {
    background: theme.colors.textGray,
    color: 'white'
  },
  ':hover': {
    background: theme.colors.iconBlue
  }
}))

export const RoundedButtonSmall = styled(Button)(
  ({ theme }) => `
  line-height: 21.33px;
  font-weight: 700;
  border-radius: 32px;
  width: 120px !important;
  heigth: 5px !important;
  color: ${theme.colors.textButton}
  text-transform: none;
  &.MuiButton-root {
    text-transform: none;
  }
  :active {
    color: ${theme.colors.highlightButtonText}
  }
`
)

const CustomTabs = props => {
  return (
    <Tabs TabIndicatorProps={{ children: <span /> }} {...props}>
      {props.children}
    </Tabs>
  )
}

export const StyledNavTabs = withStyles(CustomTabs, (theme, props) => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 86,
      width: '100%',
      backgroundColor: theme.colors.tab.selected
    },
    transition: 'none'
  },
  root: {
    height: '40px',
    minHeight: 'unset !important',
    margin: 'auto 0px'
  }
}))

const CustomTab = props => {
  return (
    <Tab disableRipple {...props}>
      {props.children}
    </Tab>
  )
}

export const StyledNavTab = withStyles(CustomTab, (theme, props) => ({
  root: {
    minWidth: 70,
    textTransform: 'none',
    color: theme.colors[props.color],
    fontWeight: '400',
    fontSize: '16px',
    '&:focus': {
      opacity: 1
    },
    transition: 'none'
  },
  selected: {
    color: `${theme.colors.basicDisabledButtonColor} !important`,
    fontWeight: '700'
  }
}))

export const CustomOutlinedInput = withStyles(
  OutlinedInput,
  (theme, props) => ({
    root: {
      height: '40px',
      '& .MuiInputBase-root': {
        '& input': {
          fontSize: '16px'
        }
      },
      '& .MuiInputBase-input': {
        fontSize: '20px'
      }
    }
  })
)

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  width: '150px',
  height: '46px',
  borderRadius: 10,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '24px',
  textTransform: 'unset',
  '&.Mui-selected, &.Mui-selected:hover': {
    color: 'white',
    backgroundColor: theme.colors.basicDisabledButtonColor
  }
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '105px',
  height: '58px',
  textTransform: 'unset',
  background: 'white',
  color: theme.colors.text,
  boxShadow: `0px 0px 10px 10px ${theme.colors.gray3}`,
  borderRadius: '8px'
}))

export const IOSSwitch = styled(props => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 37,
  height: 21,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.colors.darkThemeSwitchTrack
            : theme.colors.iconBlue,
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor:
        theme.palette.mode === 'dark'
          ? theme.colors.darkThemeSwitchTrack
          : theme.colors.text,
        opacity: 1,
        border: 0
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 17,
    height: 17
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor:
      theme.palette.mode === 'light'
        ? theme.colors.trackLight
        : theme.colors.trackDark,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}))
